class ConfigProvider {
  constructor() {
    const stage = process.env.REACT_APP_STAGE || 'dev'
    const { config } = require(`../environment-${stage}`)
    const { config: staticConfig } = require(`../environment-static`)
    this._staticConfig = staticConfig
    this._config = config
    this._config.Stage = stage
  }
  get backendEndpoint() {
    // if (this._config.Stage == 'prod') {
    //   return this._staticConfig.BackendEndpointStatic
    // } else {
    //   return this._config.BackendEndpoint
    // }
    return this._config.BackendEndpoint
  }
  get cognitoRegion() {
    return this._config.CognitoRegion
  }
  get cognitoUserPoolId() {
    return this._config.CognitoUserPoolId
  }
  get cognitoWebClientId() {
    return this._config.CognitoWebClientId
  }
  get cognitoDomain() {
    return this._config.CognitoDomain
  }
  get federatedLoginRedirectURI() {
    return this._config.FederatedLoginRedirectURI
  }
  get documentsURL() {
    return this._config.DocumentsURL
  }
  get lossIncidentsURL() {
    return this._config.LossIncidentsURL
  }
  get mitigationsURL() {
    return this._config.MitigationsURL
  }
  get mapboxPublicKey() {
    return this._staticConfig.MapboxPublicKey
  }
  get googleMapsKey() {
    return this._staticConfig.GoogleMapsKey
  }
  get stage() {
    return this._config.Stage
  }
  get faroCollectorUrl() {
    return this._config.FaroCollectorUrl
  }
  get faroAppName() {
    return this._config.FaroAppName
  }
  get faroAppNamespace() {
    return this._config.FaroAppNamespace
  }
  get faroTraceSampleRate() {
    return this._config.FaroTraceSampleRate
  }
  get appVersion() {
    return process.env.REACT_APP_VERSION
  }
  get buildSha() {
    return process.env.REACT_APP_BUILD_SHA
  }
  get buildTime() {
    return process.env.REACT_APP_BUILD_TIME
  }
  get release() {
    return [this.appVersion, this.buildSha].filter(Boolean).join('+')
  }
}

export default new ConfigProvider()
